import { InputField } from '@epages/react-components'
import type { MouseEventHandler, ReactElement } from 'react'
import cc from 'classcat'

import CheckboxField from '../formComponents/CheckboxField'
import FormValue from '../formComponents/FormValue'
import LogoUpload from './LogoUpload'

type Props = {
  logo: ImmutableMap
  onClick: MouseEventHandler<HTMLButtonElement>
  onUploadSuccess: () => void
  onError: (error: any) => void
} & TranslateProps

export default function CustomLogo({ t, logo, onClick, onUploadSuccess, onError }: Readonly<Props>): ReactElement {
  const disabled = !logo.get('active')

  return (
    <div className={cc(['ep-form-row', 'ep-custom-settings-item', { disabled }])}>
      <CheckboxField name="active" />
      <div className="ep-custom-settings-item-upload">
        <FormValue name="path">
          {(path, setPath) => <LogoUpload {...{ path, setPath, onUploadSuccess, onError }} />}
        </FormValue>
        <InputField name="title" disabled={disabled} required />
        <button
          type="button"
          className="ep-custom-settings-item-upload-delete"
          onClick={onClick}
          title={t('customLogos.deleteButton.tooltip')}
        />
      </div>
    </div>
  )
}
